import { DashboardData } from "../../types/DashboardTypes";
import { safeGET } from "./SafeClient";

export function getDashboardData(year?: number, abort?: any): Promise<DashboardData> {
    const yearQuery = year != null ? `?year=${year}` : "";
    return safeGET(`/api/dashboard/v2/data${yearQuery}`, abort);
}
